import { useState, useEffect } from 'react';
import Card from './Card/Card';
import Slider from '../UI/Slider/Slider';
import { SwiperSlide } from 'swiper/react';
import style from './price.module.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Price = () => {
  const [data, setData] = useState([]);
  const [active, setActive] = useState(1);
  const [category, setCategory] = useState('Все');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch('/api/2');
        const data = await res.json();
        setData(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filter = (newCategory, n) => {
    setCategory(newCategory);
    setActive(n);
  };

  const filteredData =
    category !== 'Все' ? data.filter((card) => card.Name === category) : data;

  if (loading) {
    return (
      <section className={style.section}>
        <div className="container">
          <div className={style.error}>
            <div className="loader"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      className={style.section}
      data-aos="fade-up"
      data-aos-duration="1200"
    >
      <div className="container">
        {/* title */}
        <div className={style.title}>
          <h2>
            Услуги и Цены по всем <span>Площадкам</span>
          </h2>
          <span>
            Выбери свою игру <b>.</b>
          </span>
        </div>

        {/* filter buttons */}
        <div className={style.nav}>
          <div className={style.buttons}>
            {['Все', 'Пейнтбол', 'Лазертаг', 'Гидробол'].map((name, index) => (
              <button
                key={name}
                onClick={() => filter(name, index + 1)}
                className={active === index + 1 ? style.active : ''}
              >
                {name}
              </button>
            ))}
          </div>
        </div>

        {/* slider */}
        <div className={style.slider}>
          <Slider loop={false} navigation={true} autoplay={false}>
            {filteredData.map((card) => (
              <SwiperSlide key={card.id}>
                <Card item={card} />
              </SwiperSlide>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Price;
